import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { register as registerSwiperElements } from 'swiper/element/bundle';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Registers the <swiper-container>/<swiper-slide> custom elements (replaces
// ngx-slick-carousel + jQuery). This is the browser entry point only
// (main.server.ts bootstraps SSR), so Swiper never loads on the server; the
// slides render as plain markup during SSR and Swiper enhances them on the client.
registerSwiperElements();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
